import React from 'react';
import { useInView } from '../hooks/useInView';

interface RevealProps {
  children: React.ReactNode;
  className?: string;
  /** Stagger delay in ms applied as a transition-delay. */
  delay?: number;
  as?: 'div' | 'section' | 'li' | 'span';
}

/**
 * Wraps content in a scroll-triggered fade + slide-up reveal.
 * Animation is defined in landing.css (.reveal / .reveal--visible) and is
 * disabled automatically via prefers-reduced-motion.
 */
export default function Reveal({ children, className = '', delay = 0, as: Tag = 'div' }: RevealProps) {
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <Tag
      ref={ref as React.Ref<any>}
      className={`reveal${inView ? ' reveal--visible' : ''}${className ? ` ${className}` : ''}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
    >
      {children}
    </Tag>
  );
}
